<template>
  <header class="app-header">
    <div class="header-cnt">
      <router-link :to="logoLink">
        <img :src="logo" class="logo" alt="Onlysales" 
          width="152px" height="32px"
        />
      </router-link>

      <div class="desktop">
        <div class="cta-btn">
          <CtaButton label="Publier une offre d'emploi" size="small" :icon="extLinkIcon" @click="onOsJobs"/>
        </div>

        <div class="menu">
          <!-- new menu -->
          <template v-for="menuItem in menu">
            <HeaderDropdown 
              :name="menuItem.name" 
              :items="menuItem.items"
              :active="menuItem.active"
              :key="menuItem.name"
            />
          </template>
        </div>
      </div>

      <div class="menu-mobile mobile">
        <div class="burger">
          <Slide right :cross-icon="true" :closeOnNavigation="false" :width="screenWidth">
            <router-link to="/">
              <img :src="logo" class="logo" alt="Onlysales" 
                width="152px" height="32px"
              />
            </router-link>
            
            <div class="dropdown-wrapper">
              <template v-for="menuItem in menu">
                <MobileHeaderDropdown 
                  :name="menuItem.name" 
                  :items="menuItem.items"
                  :active="menuItem.active"
                  :key="menuItem.name"
                />
              </template>
            </div>
            
            <CtaButton label="Publier une offre d'emploi" size="small" :icon="extLinkIcon" @click="onOsJobs"/>
          </Slide>
        </div>
      </div>

    </div>
  </header>
</template>

<script>
import CtaButton from "./atoms/CtaButton.vue"
import extLinkIcon from "../assets/ext-link.svg"
import HeaderDropdown from "./atoms/HeaderDropdown.vue"
import MobileHeaderDropdown from "./atoms/MobileHeaderDropdown.vue"

import { Slide } from 'vue-burger-menu'

export default {
  name: "AppHeader",
  components: {
    CtaButton,
    Slide,
    HeaderDropdown,
    MobileHeaderDropdown,
  },
  props: {
    logo: {
      type: String,
      required: true,
    },
    active: {
      type: String,
      required: false,
    },
    logoLink: {
      type: String,
      default: "/",
    },
  },
  data() {
    return {
      extLinkIcon,
      screenWidth: '' + window.innerWidth,

      menu: [{
        name: "Recruteurs",
        active: this.active == "recruteurs",
        items: [{
          title: "Recrutez un commercial",
          description: "Trouvez des talents grâce à notre équipe de chasseurs de tête 100% spécialisés.",
          icon: "navIconRecruiter",
          link: "https://tracker.onlysales.fr",
          isNew: false,
        }, {
          title: "Recherchez un profil",
          description: "Accédez gratuitement au 1er annuaire de commerciaux de France.",
          icon: "navIconProfile",
          link: "https://profiles.onlysales.fr",
          isNew: true,
          isExt: true,
        }, {
          title: 'Publiez une offre',
          description: "Diffusez gratuitement votre offre d'emploi sur le site d'emploi 100% commerciaux.",
          icon: "navIconPublish",
          link: "https://onlysales.fr",
          isNew: false,
          isExt: true,
        }, 
        // {
        //   title: 'Formez vos talents',
        //   description: "Découvrez nos formations entièrement dédiées aux commerciaux.",
        //   icon: "navIconAcademy",
        //   link: "https://onlysalesacademy.fr",
        //   isNew: false,
        // }
        ]
      }, {
        name: "Commerciaux",
        active: this.active == "commerciaux",
        items: [{
          title: "Trouvez un emploi commercial",
          description: "Consultez des offres en fonction de critères qui comptent : type de mission, points forts.",
          icon: "navIconPublish",
          link: "https://onlysales.fr",
          isNew: false,
          isExt: true,
        }, {
          title: "Publiez votre profil commercial",
          description: "Augmentez votre visibilité grâce au 1er annuaire de commerciaux de France.",
          icon: "navIconProfile",
          link: "https://onlysales.fr",
          isNew: false,
          isExt: true,
        },
        //  {
        //   title: 'Formez-vous',
        //   description: "Montez en compétence avec nos formations.",
        //   icon: "navIconAcademy",
        //   link: "https://onlysalesacademy.fr",
        //   isNew: false,
        // }, {
        //   title: 'Echangez',
        //   description: "Échangez des contacts et des affaires grâce à notre Club d'affaire.",
        //   icon: "navIconClub",
        //   link: "https://onlysalesclub.fr",
        //   isNew: false,
        // }
        ]
      }, {
        name: "Ressources",
        active: this.active == "ressources",
        items: [{
          title: "Blog",
          description: "Les dernières tendances pour les recruteurs et commerciaux.",
          icon: "navIconBlog",
          link: "https://blog.onlysales.fr",
          isNew: false,
        }, {
          title: "Glossaire",
          description: "Nous parlons le même langage. ",
          icon: "navIconGlossary",
          link: "https://blog.onlysales.fr/glossaire",
          isNew: false,
        }, {
          title: "Fiches métiers",
          description: "Explorez nos fiches métiers spécialisées.",
          icon: "navIconJobs",
          link: "https://blog.onlysales.fr/fiches-metiers",
          isNew: true,
        }]
      }]
    }
  },
  computed: {
    isGlossaryPage() {
      return this.$route.path.slice(0, 10) === "/glossaire"
    },
  },
  methods: {
    onOsJobs() {
      window.open("https://onlysales.fr", "_blank")
    },
    handleResize() {
      this.screenWidth = '' + window.innerWidth
    }
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
};
</script>

<style lang="scss">

.app-header {
  background: $neutral25;
  height: 80px;
  padding-top: 24px;
  border-bottom: 1px solid $neutral200;

  .header-cnt {
    margin: 0 auto;
    width: $desktopContainer;

    .logo {
      height: 32px;
      float: left;
    }

    .menu {
      width: 100%;
      text-align: center;
    }

    .cta-btn {
      float: right;
    }

    .menu-item {
      display: inline-block;

      font-family: "Open Sans";
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      letter-spacing: 0px;
      text-align: left;
      color: $neutral900;

      position: relative;
      top: 4px;
      padding-bottom: 4px;
      margin-right: 32px;

      a {
        color: $neutral900;
        text-decoration: none;
      }
      
      &.active, &:hover {
        border-bottom: 2px solid $primary300;
      }

      &.btn {
        background: $primary300;
        margin-left: 20px;
      }
    }

    .menu-mobile {
      width: 100%;
      text-align: right;

      .burger {
        .dropdown-wrapper {
          display: block;
          height: calc(100vh - 152px);
          overflow-y: auto;
          padding: 0;
          background: $neutral50;
        }

        .bm-menu {
          padding-top: 20px;
          background: $neutral25;

          .bm-item-list {
            position: relative;
            margin-left: 0;
            width: 100vw;

            & > a {
              padding: 0px 24px 16px;
              padding-top: 0;
              border-bottom: 1px solid $neutral200;
            }
          }

          .bm-cross-button {
              position: absolute;
              top: 26px;
              left: calc(100% - 48px);
              right: auto!important;
  
              span {
                display: none;
              }
  
              &::before {
                content: "";
                display: inline-block;
                opacity: 0;
                transition: opacity 0.3s ease-in-out;
                width: 24px;
                height: 24px;
                background: url("../assets/close.svg") no-repeat center center;
                background-size: contain;
              }
            }
        }
      }

      .bm-burger-button {
        width: 32px;
        height: 32px;
        
        padding: 8px;
        top: 18px;
        right: 22px!important;

        span {
          display: none;
        }

        &::before {
          content: "";
          display: inline-block;
          width: 24px;
          height: 24px;
          background: url("../assets/burger.svg") no-repeat center center;
          background-size: contain;
        }
      }

      .cstm-button {
        border-top: 1px solid $neutral200;
        padding-top: 24px;
      }
    }
  }
}

.bm-overlay .bm-cross-button::before {
  opacity: 1!important;
}

@media screen and (max-width: $mobileBreakpoint) {
  .app-header {
    height: 72px;
    padding-top: 20px;

    .header-cnt {
      width: calc(100vw - 68px)
    }
  }
}

</style>